import { addMonths } from 'date-fns/addMonths';
import { isBefore } from 'date-fns/isBefore';
import { format } from 'date-fns/format';
import React from 'react';
import { SelectableItem } from '../../../../../../models/CampaignModel';
import { ProductType } from '../../../../../../models/product/ProductType';
import { formatAmount, formatRecurringAmount } from '../../../../../../utils/format';
import BasketListItem from './BasketListItem';

interface Props {
  product: SelectableItem;
  hideIfFree?: boolean;
}

const BasketProduct: React.FC<Props> = ({ product, hideIfFree = false }) => {
  const { price, originalPrice, offerPeriodInMonths, isRecurring, offerEndDate } = product.pricing;
  if (hideIfFree && price === 0) {
    return null;
  }
  const name = product.displayData.name;

  let priceLabel = product.productType === ProductType.Premium ? `${formatAmount(price)}/mnd` : `${formatAmount(price)}`;

  const isReducedRecurringOffer = isRecurring && price < originalPrice && offerPeriodInMonths && offerPeriodInMonths > 0;
  if (isReducedRecurringOffer) {
    const endDate = offerEndDate ? new Date(offerEndDate) : new Date();
    const priceSuffix = isBefore(endDate, addMonths(new Date(), 1))
      ? `til ${format(endDate, 'dd.MM.yyyy')}.`
      : `/mnd i ${offerPeriodInMonths} mnd.`;
    priceLabel = `${formatAmount(price)}${priceSuffix}`;
  }

  const details = isReducedRecurringOffer ? `Originalpris ${formatRecurringAmount(originalPrice)}` : ``;

  const originalPricing = originalPrice !== price ? formatAmount(originalPrice) : undefined;

  return (
    <BasketListItem
      name={name}
      priceLabel={priceLabel}
      originalPrice={originalPricing}
      details={details}
      id={product.id}
      optionalCurrentPriceTitle={product.displayData.optionalPriceTitle}
    />
  );
};

export default BasketProduct;
